module.exports = __webpack_public_path__ + "img/swainsons-thrush.7f5def51.jpg";